import React from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  return (
    <footer className="section footer-section" style={{ opacity: 0.85 }}>
      <div className="col-md-6 contact-info contact">
        <div style={{ minWidth: "190px" }}>
          <p>
            <span className="d-block">
              <span className="ion-ios-location h5 mr-3 text-primary"></span>{" "}
              Adresse:
            </span>{" "}
            <span>
              Via Firenzuola <br />
              08020 Agrustos
              <br />
              Sardinien
            </span>
          </p>
        </div>
        <div style={{ minWidth: "190px" }}>
          <p>
            <span className="d-block">
              <span className="ion-ios-telephone h5 mr-3 text-primary"></span>{" "}
              Tel:
            </span>{" "}
            <span> (+43) 676 725 93 13</span>
          </p>
        </div>
        <div style={{ minWidth: "190px" }}>
          <p>
            <span className="d-block">
              <span className="ion-ios-email h5 mr-3 text-primary"></span>{" "}
              Email:
            </span>{" "}
            <span> info@casa-wadowski.com</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
